<template>
  <div class="nd-tabbar">
    <router-link
      class="nd-tabbar-item"
      :to="item.path"
      v-for="(item, index) in newTabList"
      :key="index"
    >
      <img
        v-if="$route.path !== item.path"
        :src="$route.path === item.path ? item.activeIcon : item.icon"
      >
      <div
        class="wappper"
        v-if="$route.path === item.path && $route.path === '/'"
      >
        <lottie
          class="animation"
          :options="defaultOptions"
          v-on:animCreated="handleAnimation"
        />
      </div>
      <div
        class="wappper"
        v-if="$route.path === item.path && $route.path === '/mine'"
      >
        <lottie
          class="animation"
          :options="defaultOptions1"
          v-on:animCreated="handleAnimation"
        />      
      </div>
      <div
        class="wappper"
        v-if="$route.path === item.path && $route.path === '/find'"
      >
        <lottie
          class="animation"
          :options="defaultOptions2"
          v-on:animCreated="handleAnimation"
        />
      </div>
      <span>{{ item.name }}</span>
      <span class="winCash"  v-if="(showOwnTips==='Y' || showOwn=='Y') && item.path ==='/mine'">赢现金</span>
    </router-link>
    <i class="dot" v-if="showDot && showDotProp && !isQlc && fundPage==='Y'"></i>
  </div>
</template>
<script>
import homeIcon from './images/home.png'
import homeActiveIcon from './images/home_active.png'
import mineIcon from './images/mine.png'
import mineActiveIcon from './images/mine_active.png'
import faxianIcon from './images/faxian01@2x.png'
import faxianActiveIcon from './images/faxian2@2x.png'
import Lottie from 'vue-lottie'
import animationData0 from './images/tab_home.json'
import animationData1 from './images/tab_mine.json'
import animationData2 from './images/faxian.json'
import { mapActions } from 'vuex'
export default {
  name: 'nd-tabbar',
 
  components: {
    Lottie
  },
  props: {
    showDotProp: {
      type: Boolean,
      default: true
    },
    showOwn: {
      type: String,
      default: '' 
    },
    tabList: {
      type: Array,
      default: () => [
        {
          icon: homeIcon,
          activeIcon: homeActiveIcon,
          name: '首页',
          path: '/'
        },
        {
          icon: faxianIcon,
          activeIcon: faxianActiveIcon,
          name: '发现',
          path: '/find'
        },
        {
          icon: mineIcon,
          activeIcon: mineActiveIcon,
          name: '我的',
          path: '/mine'
        }
      ]
    }
  },
  async mounted () {
    if (!this.showOwn) {
      this.getCashIcon()
    }
    this.mineConfig()
 
    const { success, data } = await this.fundPageRoute()
    if (success && data) {
      if (data.memberGoodsCd) {
        this.tabList[1].name = '会员'
      }
    }
  },
  data () {
    return {
      showOwnTips: 'N',
      fundPage: 'N',
      defaultOptions: {
        animationData: animationData0,
        loop: false
      },
      defaultOptions1: {
        animationData: animationData1,
        loop: false
      },
      defaultOptions2: {
        animationData: animationData2,
        loop: false
      }
    }
  },
  methods: {
    async mineConfig () {
      const { success, data } = await this.mineConfigX({
        version: '1.1.1'
      })
      if (success) {
        const { fundPage } = data?.entranceConfig
        this.fundPage = fundPage
      }
    },
    handleAnimation (anim) {
      this.anim = anim
    },
    ...mapActions('user', ['fundPageRoute', 'queryXiaomeiIconX', 'mineConfigX']),
    async getCashIcon () {
      const { success, data } = await this.queryXiaomeiIconX()
      if (success) {
        this.showOwnTips = data.showOwn
      }
    }
  },

   
  computed: {
    newTabList () {
      if (!this.isQlc && this.fundPage === 'N') {
        return this.tabList.filter((item) => item.path !== '/find')
      } else {
        return this.tabList
      }
    },
    showDot () {
      return !sessionStorage.getItem('showDot')
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-tabbar {
  border-top: 1px solid #eeeeee;
  width: 750px;
  height: calc(env(safe-area-inset-bottom) + 98px);
  background-color: #ffffff;
  position: fixed;
  bottom: -1px;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  z-index: 999;
  .winCash {
    position: absolute;
    top:3px;
    background: #FF4633;
    color: #fff !important;
    padding: 2px 8px;
    border-radius: 100px 100px 100px 0px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px !important;
    left: 50%;
    transform: translateX(20px);
    white-space: nowrap;
  }
  .dot {
    width:12px;
    height:12px;
    position: absolute;
    background: red;
    position: absolute;
    border-radius: 100%;
    left:50%;
    margin-left: 20px;
    top:18px
  }
  .nd-tabbar-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .wappper {
      height: 48px;
      width: 48px;
    }

    img {
      width: 48px;
      height: 48px;
      margin-top: 5px;
    }

    span {
      font-size: 20px;
      margin-top: 3px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
    }

    &.router-link-exact-active {
      span {
        color: @theme;
      }
    }
  }
}
</style>